import React, {Component} from 'react';
import {Row, Col, Button} from 'react-bootstrap';
import {NavLink} from 'react-router-dom';

//CSS
import '../../LandingSubcomponents/Servicios.css';

//Images
import chango from '../../../../assets/img/whatsapp-people.png';
import whats from '../../../../assets/img/servicios/compra-online/chango.png';

class ConsultasWhatsapp extends Component {
    render() {
        return (
            <Row className="pedidos-online" style={{borderBottom:"none"}}>
                <div className="container">
                    <div className="img-whatsapp">
                        <img className="img-responsive" src={chango} alt="chango-supermercado"/>
                    </div>
                    <div className="desc-whatsapp">
                        <h3>
                            ¡Hacé tus consultas de forma rápida!
                        </h3>

                        <a alt="Chatea con nosotros" href="https://api.whatsapp.com/send?phone=5493412153690"
                           target="_blank">
                            <Button className="btn-primary">
                                WhatsApp
                            </Button>
                        </a>

                        <h6>
                            Agendá nuestro WhatsApp
                        </h6>
                        <h4>341 215 3690</h4>
                        <ul>
                            <li>Solicitá un vendedor</li>
                            <li>Recibí ofertas y novedades</li>
                            <li>Hacé tus consultas</li>
                            <li>Realizá tus pedidos</li>
                        </ul>

                    </div>

                </div>
            </Row>
        );
    }
}


export default ConsultasWhatsapp;


// WEBPACK FOOTER //
// ./src/pages/LandingPage/LandingSubcomponents/Servicios/ConsultasWhatsapp.js